import cx from 'clsx';

import { PlainModal } from '@/components/modals/plain-modal';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const EmergencyBrakeAssistModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerEmergencyBrakeAssistModal}
    contentClassName={cx(
      styles.containerContent,
      styles.isFullWidth,
    )}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      Deploys additional braking power to help the car come to a stop
      quicker during an emergency braking situation.
    </div>
  </PlainModal>
);
